import React from 'react'
import { OutputSettingProps } from '../../../../Types/Workflow-Types'
import VideocamOutlinedIcon from '@mui/icons-material/VideocamOutlined';

const OutputSettingVideo=({readOnly}:OutputSettingProps)=> {

    return (
    <span className="typeInput-output" style={{ opacity: 0.7 }}>
      <span className="me-1">
        <VideocamOutlinedIcon
          className={`app-icon Video`}
          sx={{
            fontSize:"20px",
          }}
        />
      </span>
      <span className="ms-1">Video</span>
    </span>
    )
}

export default OutputSettingVideo
